import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  copy(){
    navigator.clipboard.writeText(event.target.value);
    alert('Número copiado para a sua área de transferência(clipboard).');
  }
}
